export default __webpack_public_path__ + "static/media/signup.95f2b3ee.png";